import React, { useEffect, useState } from "react";
import { TbReplace } from "react-icons/tb";
import { LuReplace } from "react-icons/lu";
import {
  FaTrash,
  FaArrowLeft,
  FaShare,
  FaEdit,
  FaInfoCircle,
  FaShieldAlt,
  FaHistory,
} from "react-icons/fa";
import { useParams, useNavigate } from "react-router-dom";
import { NavLink } from "react-router-dom";
import { useSelector } from "react-redux";
import AssetBasicDetails from "./AssetBasicDetails";
import AssetHistory from "./AssetHistory";

import { GrHostMaintenance } from "react-icons/gr";
import { Spinner } from "react-bootstrap";

import AssetAllocateModal from "../ActionModal/AssetAllocateModal";
import AssetDisposeModal from "../ActionModal/AssetDisposeModal";
import AssetMoveRequestModal from "../ActionModal/AssetMoveRequestModal";

import { UnitStatusBadge } from "../../../components";
import { AssetDetailsApi } from "../../../services/AssetService";
import AssetMaintenanceModal from "../ActionModal/AssetMaintenanceModal";
import AssetMaintenanceCompleteModal from "../ActionModal/AssetMaintenanceComplete";
import AssetForceReturnModal from "../ActionModal/AssetForceReturnModal";
import AssetMoveCancelModal from "../ActionModal/AssetMoveCancelModal";

const AssetDetail = () => {
  const { id, type } = useParams();
  const navigate = useNavigate();
  const currentUser = useSelector((state) => state.auth.user);
  const [tabType, setTabType] = useState("");
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [allocateModal, setAllocateModal] = useState(false);
  const [requestModal, setRequestModal] = useState(false);
  const [moveCancelModal, setMoveCancelModal] = useState(false);
  const [disposalmodal, setDisposalModal] = useState(false);
  const [maintenanceModal, setMaintenanceModal] = useState(false);
  const [maintenanceCompleteModal, setMaintenanceCompleteModal] =
    useState(false);
  const [forceReturnToggle, setForceReturnToggle] = useState(false);
  const handleForceReturnToggle = () => {
    setForceReturnToggle(!forceReturnToggle);
  };
  const handleToggleAllocateModal = () => {
    setAllocateModal(!allocateModal);
  };

  const handleToggleRequestModal = () => {
    setRequestModal(!requestModal);
  };

  const handlToggleMaintenanceModal = () => {
    setMaintenanceModal(!maintenanceModal);
  };

  const handlToggleMaintenanceCompleteModal = () => {
    setMaintenanceCompleteModal(!maintenanceCompleteModal);
  };

  const handleToggleMoveCancelModal = () => {
    setMoveCancelModal(!moveCancelModal);
  };
  const getUnitDetails = () => {
    setLoading(true);
    AssetDetailsApi(id)
      .then((res) => {
        setError("");
        setData(res?.data?.results);
      })
      .catch((err) => {
        setError(
          err?.response?.data?.message ||
            err?.response?.data?.error ||
            "Try again later"
        );
      })
      .finally(() => {
        setLoading(false);
      });
  };
  useEffect(() => {
    setTabType(type || "");
  }, [type]);
  useEffect(() => {
    getUnitDetails();
  }, []);
  const tabs = [
    {
      name: "Overview",
      icons: <FaInfoCircle className="me-1" />,
      path: `/asset/${id}/basic-details`,
    },
    {
      name: "History",
      icons: <FaHistory className="me-1" />,
      path: `/asset/${id}/history-details`,
    },
  ];
  const tabComponent = {
    "basic-details": <AssetBasicDetails data={data} action={getUnitDetails} />,
    "history-details": <AssetHistory />,
  };

  const handleAfterAllocateSubmit = (data) => {
    handleToggleAllocateModal();
    getUnitDetails();
  };
  const handleAfterDisposalSubmit = (data) => {
    setDisposalModal(false);
    getUnitDetails();
  };
  const handleAfterMoverequestSubmit = () => {
    handleToggleRequestModal();
    getUnitDetails();
  };
  const handleAfterMaintenanceSubmit = () => {
    handlToggleMaintenanceModal();
    getUnitDetails();
  };
  const handleAfterMaintenanceCompleteSubmit = () => {
    handlToggleMaintenanceCompleteModal();
    getUnitDetails();
  };
  const handleAfetrForceReturnSubmit = () => {
    handleForceReturnToggle();
    getUnitDetails();
  };
  const handleAftreMoveCancelSubmit = () => {
    handleToggleMoveCancelModal();
    getUnitDetails();
  };
  return (
    <>
      {loading ? (
        <div className="my-5 text-center">
          <Spinner animation="border" />
        </div>
      ) : error ? (
        <div className="my-5 text-center text-danger">{error}</div>
      ) : data ? (
        <div>
          <div className="card px-4 py-2">
            <div className="d-flex justify-content-between align-items-center flex-wrap gap-3">
              <div className="d-flex gap-2">
                <button
                  className="btn rounded-1 py-2 stylish-transparent-btn align-self-center"
                  onClick={() => navigate("/assets/table-view")}
                >
                  <FaArrowLeft />
                </button>
                <div className="d-flex flex-column">
                  <div className="d-flex align-items-ceter gap-2">
                    <h3 className="mb-0">{data?.name || "-"}</h3>
                    <UnitStatusBadge status={data?.status} />
                  </div>
                  <div>
                    <span className="small" style={{ fontSize: "0.8rem" }}>
                      {data?.category || "-"} &gt; {data?.sub_category || "-"}
                    </span>
                  </div>
                </div>
              </div>

              <div className="d-flex gap-2 flex-wrap">
                {["IN_STOCK"].includes(data?.status) &&
                  currentUser.role == "STORE" &&
                  (data?.movement?.status == "PENDING" ? (
                    <button
                      className="btn rounded-2 btn-outline-danger align-self-center"
                      style={{ padding: "0.3rem 0.9rem" }}
                      onClick={handleToggleMoveCancelModal}
                    >
                      <TbReplace className="me-1" />
                      Cancel Move
                    </button>
                  ) : (
                    <>
                      <button
                        className="btn rounded-2 stylish-transparent-btn align-self-center"
                        style={{ padding: "0.3rem 0.9rem" }}
                        onClick={handleToggleRequestModal}
                      >
                        <TbReplace className="me-1" />
                        Move
                      </button>
                      <button
                        className="btn rounded-2 btn-outline-info align-self-center"
                        style={{ padding: "0.3rem 0.9rem" }}
                        onClick={handleToggleAllocateModal}
                      >
                        <FaShare className="me-1" />
                        Allocate
                      </button>
                    </>
                  ))}
                {data?.movement?.status !== "PENDING" && (
                  <>
                    {["ALLOCATED"].includes(data?.status) &&
                      currentUser.role === "STORE" &&
                      data.allocation && (
                        <button
                          className="btn rounded-2 btn-outline-danger align-self-center"
                          style={{ padding: "0.3rem 0.9rem" }}
                          onClick={handleForceReturnToggle}
                        >
                          <FaShare className="me-1" />
                          Force Return
                        </button>
                      )}

                    {["IN_STOCK"].includes(data?.status) &&
                      currentUser.role === "STORE" && (
                        <>
                          <button
                            className="btn rounded-2 btn-outline-warning align-self-center"
                            style={{ padding: "0.3rem 0.9rem" }}
                            onClick={handlToggleMaintenanceModal}
                          >
                            <GrHostMaintenance className="me-1" />
                            Maintenance
                          </button>
                          <button
                            className="btn rounded-2 btn-outline-danger align-self-center"
                            style={{ padding: "0.3rem 0.9rem" }}
                            onClick={() => setDisposalModal(true)}
                          >
                            <FaTrash className="me-1" />
                            Dispose
                          </button>
                        </>
                      )}

                    {["IN_REPAIR"].includes(data?.status) &&
                      currentUser.role === "STORE" && (
                        <button
                          className="btn rounded-2 btn-outline-success align-self-center"
                          style={{ padding: "0.3rem 0.9rem" }}
                          onClick={handlToggleMaintenanceCompleteModal}
                        >
                          <GrHostMaintenance className="me-1" />
                          Complete Repair
                        </button>
                      )}
                  </>
                )}
              </div>

              <ul className="nav custom-sidebar-nav gap-3">
                {tabs.map((tab) => (
                  <li className="nav-item" key={tab.name}>
                    <NavLink
                      to={tab.path}
                      end={true}
                      className={({ isActive }) =>
                        "nav-link" + (isActive ? " active" : "")
                      }
                    >
                      {tab.icons}
                      {tab.name}
                    </NavLink>
                  </li>
                ))}
              </ul>
            </div>
          </div>
          <div className="mt-3">{tabComponent[tabType]}</div>
        </div>
      ) : (
        ""
      )}
      <AssetAllocateModal
        isRfidExist={data?.rfid_tag_id ? true : false}
        visible={allocateModal}
        onClose={handleToggleAllocateModal}
        id={id}
        onAfterSubmit={(data) => handleAfterAllocateSubmit(data)}
      />
      <AssetMoveRequestModal
        visible={requestModal}
        onClose={handleToggleRequestModal}
        id={id}
        afterSubmit={handleAfterMoverequestSubmit}
        locationId={data?.delivery_location?.id || ""}
      />
      <AssetDisposeModal
        id={id}
        open={disposalmodal}
        onClose={() => setDisposalModal(false)}
        afterSubmit={handleAfterDisposalSubmit}
      />
      <AssetMaintenanceModal
        id={id}
        open={maintenanceModal}
        onClose={handlToggleMaintenanceModal}
        afterSubmit={handleAfterMaintenanceSubmit}
      />
      <AssetMaintenanceCompleteModal
        id={id}
        open={maintenanceCompleteModal}
        onClose={handlToggleMaintenanceCompleteModal}
        afterSubmit={handleAfterMaintenanceCompleteSubmit}
      />
      <AssetForceReturnModal
        assetData={data}
        open={forceReturnToggle}
        onClose={handleForceReturnToggle}
        afterSubmit={handleAfetrForceReturnSubmit}
      />
      <AssetMoveCancelModal
        assetData={data}
        open={moveCancelModal}
        onClose={handleToggleMoveCancelModal}
        afterSubmit={handleAftreMoveCancelSubmit}
      />
    </>
  );
};

export default AssetDetail;
